"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return (vue_2.pushScopeId("data-v-325d2a5a"), n = n(), vue_2.popScopeId(), n); };
var _hoisted_1 = { class: "Check" };
var _hoisted_2 = { class: "top-nav scrollbar" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__icon bg-user_business" }, null, -1); });
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__title" }, "Вход в кабинет", -1); });
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__text" }, "Если уже зарегистрированные у нас", -1); });
var _hoisted_6 = [
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
];
var _hoisted_7 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__icon bg-registration" }, null, -1); });
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__title" }, "Регистрация", -1); });
var _hoisted_9 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__text" }, "Если покупаетет в первый раз", -1); });
var _hoisted_10 = [
    _hoisted_7,
    _hoisted_8,
    _hoisted_9
];
var _hoisted_11 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__icon bg-click_tap" }, null, -1); });
var _hoisted_12 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__title" }, "Купитьв 1 клик", -1); });
var _hoisted_13 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "item__text" }, "Отправьте заказ и мы оформим его за вас", -1); });
var _hoisted_14 = [
    _hoisted_11,
    _hoisted_12,
    _hoisted_13
];
var login_vue_1 = require("./login.vue");
var oneClick_vue_1 = require("./oneClick.vue");
var registration_vue_1 = require("./registration.vue");
var vue_3 = require("vue");
exports.default = vue_1.defineComponent({
    setup: function (__props) {
        var action = vue_3.ref('login');
        return function (_ctx, _cache) {
            return (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_1, [
                vue_2.createElementVNode("div", _hoisted_2, [
                    vue_2.createElementVNode("button", {
                        class: vue_2.normalizeClass(["item", { 'active': action.value === 'login' }]),
                        onClick: _cache[0] || (_cache[0] = function ($event) { return (action.value = 'login'); })
                    }, _hoisted_6, 2),
                    vue_2.createElementVNode("button", {
                        class: vue_2.normalizeClass(["item", { 'active': action.value === 'registration' }]),
                        onClick: _cache[1] || (_cache[1] = function ($event) { return (action.value = 'registration'); })
                    }, _hoisted_10, 2),
                    vue_2.createElementVNode("button", {
                        class: vue_2.normalizeClass(["item", { 'active': action.value === 'oneClick' }]),
                        onClick: _cache[2] || (_cache[2] = function ($event) { return (action.value = 'oneClick'); })
                    }, _hoisted_14, 2)
                ]),
                (action.value === 'login')
                    ? (vue_2.openBlock(), vue_2.createBlock(login_vue_1.default, { key: 0 }))
                    : vue_2.createCommentVNode("", true),
                (action.value === 'oneClick')
                    ? (vue_2.openBlock(), vue_2.createBlock(oneClick_vue_1.default, { key: 1 }))
                    : vue_2.createCommentVNode("", true),
                (action.value === 'registration')
                    ? (vue_2.openBlock(), vue_2.createBlock(registration_vue_1.default, { key: 2 }))
                    : vue_2.createCommentVNode("", true)
            ]));
        };
    }
});
